'use client';
import { Dispatch, SetStateAction, useRef, useState } from 'react';
import ShippingAddress from '@/components/customercenter-ui/address/guestCheckout/ShippingAddress';
import GuestShipping from '@/components/customercenter-ui/checkout/guestShipping';
import { Dialog, DialogContent } from '../../ui/dialog';
import Loader from '../../ui/loader';

interface ShippingAddress {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  data: any;
  cartData: any;
  setShippingAddress?: any;
  shippingAddress?: any;
}

const ShippingEditAddressModal = ({
  open,
  setOpen,
  data,
  cartData,
  setShippingAddress,
  shippingAddress,
}: ShippingAddress) => {
  const resetRef = useRef<(() => void) | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Dialog
      open={open}
      onOpenChange={(value) => {
        if (!value) {
          resetRef?.current?.();
        }
        setOpen(value);
      }}
    >
      <DialogContent className="custom-scrollbar max-h-[90%] max-w-[520px] overflow-y-auto bg-white sm:rounded-md">
        {isLoading && <Loader />}

        {open ? (
          <GuestShipping
            key={shippingAddress?.addressId ?? 'order-shipping'}
            data={data}
            onPaymentPage={false}
            cartData={cartData}
            isOrderDetails={true}
            setOpen={setOpen}
            setOrderShippingAddress={setShippingAddress}
            orderShippingAddress={shippingAddress}
            setIsEditShippingLoading={setIsLoading}
            registerReset={(fn) => {
              resetRef.current = fn;
            }}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default ShippingEditAddressModal;
